import { OnInputChangeEventsTransformer } from 'views/Widgets/Forms/ValidatedForm';

export const excludeEventsOnExistingNonTrivialProperties: OnInputChangeEventsTransformer =
  (eventOrEvents: any[] | any, object: unknown) => {
    if (!Array.isArray(eventOrEvents)) {
      throw new Error(
        'excludeEventsOnExistingNonTrivialProperties expects an array of events'
      );
    }
    return eventOrEvents
      .filter((event) => {
        const name = event?.target?.name;
        return (
          name &&
          object &&
          (object[name] === undefined ||
            object[name] === null ||
            object[name] === '' ||
            // case of skills, tags, etc.
            (Array.isArray(object[name]) && object[name].length === 0) ||
            // case of objects(likert)
            (typeof object[name] === 'object' && !Array.isArray(object[name])))
        );
      })
      .map((event) => {
        const name = event?.target?.name;
        // Transform likert suggestions to merge with existing values
        if (
          name &&
          object &&
          object[name] !== null &&
          typeof object[name] === 'object' &&
          !Array.isArray(object[name])
        ) {
          const existingValue = object[name];
          const value = event?.target?.value;
          return {
            target: {
              name,
              value: {
                // merge existing value with the new one
                // but leave the precedence with the existing value,
                // since the rest of the suggestions are explicitly
                // asked with a question
                ...value,
                ...existingValue,
              },
            },
          };
        }
        return event;
      })
      .filter((event) => !!event);
  };
